/** Every tunable race constant in one mutable object. The ?debug tuning
 * panel edits these fields directly; races snapshot params/rules at setup,
 * so edits reach the NEXT race and running races stay deterministic. */

export const RACE_TICK_S = 1 / 30;

export interface RaceTuning {
  // flats shared by every horse
  vBase: number;
  vExhausted: number;
  dragK: number;
  exhaustedDragK: number;
  /** Regen multiplier while blown — the horse catches its breath. */
  exhaustedRegenMul: number;
  tapCost: number;
  regenDelayS: number;
  gateBoostS: number;
  // stat → parameter lines
  vMaxBase: number;
  vMaxPerSpeed: number;
  tapImpulseBase: number;
  tapImpulsePerAccel: number;
  staminaBase: number;
  staminaPerStamina: number;
  regenBase: number;
  regenPerHeart: number;
  gateAccelBase: number;
  gateAccelPerAccel: number;
  // race rules
  countdownS: number;
  perfectWindowS: number;
  minTapIntervalS: number;
  flinchSuppressS: number;
  perfectGateMul: number;
  recoverFraction: number;
  timeoutS: number;
}

export const RACE_TUNING: RaceTuning = {
  vBase: 8.0,
  vExhausted: 7.2,
  dragK: 0.5,
  exhaustedDragK: 1.8,
  exhaustedRegenMul: 2.0,
  tapCost: 5.0,
  regenDelayS: 0.3,
  gateBoostS: 3.0,

  vMaxBase: 12.0,
  vMaxPerSpeed: 0.35,
  tapImpulseBase: 0.8,
  tapImpulsePerAccel: 0.2,
  staminaBase: 45,
  staminaPerStamina: 8,
  regenBase: 2.5,
  regenPerHeart: 1.4,
  gateAccelBase: 1.5,
  gateAccelPerAccel: 0.4,

  countdownS: 2.4,
  perfectWindowS: 0.15,
  minTapIntervalS: 0.1,
  flinchSuppressS: 0.5,
  perfectGateMul: 1.25,
  recoverFraction: 0.22,
  timeoutS: 90,
};
